import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 25C1F858-600D-42A4-801F-5F85F22ACB52
 * name credit-card-multiple
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-multiple.svg
 * tags
 * - Banking 
 */
export const CreditCardMultipleIcon = createSvgIcon(<><path d="M21 9V6H7V9H21M21 3A2 2 0 0 1 23 5V15A2 2 0 0 1 21 17H7A2 2 0 0 1 5 15V5A2 2 0 0 1 7 3H21M3 19H18V21H3A2 2 0 0 1 1 19V8H3Z" /></>, 'CreditCardMultipleIcon');
export default CreditCardMultipleIcon